import axios from 'axios'
import router from '../router'

// 创建 axios 实例
const http = axios.create({
//   baseURL: 'http://2400855f.r5.cpolar.cn',
  timeout: 10000 // 请求超时时间
})


// 响应拦截器
http.interceptors.response.use(
  response => {
    // 正常响应直接返回
    return response
  },
  error => {
    // 处理错误响应
    if (error.response && error.response.status === 401) {
      // 登录失效，清除本地存储的 token
      localStorage.removeItem('token')
      
      router.push('/login')
      
    }
    // 其他错误直接返回，让调用方处理
    return Promise.reject(error)
  }
)

export default http